import * as React from 'react';

import Support from '../../components/settings/Support';


class SettingsSupport extends React.Component<any, any> {
  render() {
    return (
      <Support />
    );
  }
}

export default SettingsSupport;
